import { styled } from 'styled-components';
import { theme } from '../../constants/theme.mjs';
"use strict";
const InnerWrap = styled.div`
  font-size: ${theme.font.size14};
`;
export { InnerWrap };
//# sourceMappingURL=Modal.styles.mjs.map
